// Keep Shopify's live instalment message alongside accelerated checkout.
(() => {
  const start = () => {
    const product = document.getElementById('main-product');
    if (!product) return;
    let frame;
    const place = () => {
      frame = null;
      const payment = product.querySelector('.shopify-payment-button');
      const terms = product.querySelector('.shopify-installments-container');
      if (payment && terms && payment.nextElementSibling !== terms) {
        payment.after(terms);
        terms.classList.add('qgc-installments-below-payment');
      }
    };
    place();
    new MutationObserver(() => { if (!frame) frame = requestAnimationFrame(place); }).observe(product, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();

// Compact product cards retain a sharp source at the actual rendered width.
(() => {
  const selector = '.qgc-product-related .l4cl figure img, [id*="recently-viewed"] .l4cl figure img, [id*="recommendations"] .l4cl figure img';
  const size = image => { const width = Math.ceil(image.getBoundingClientRect().width); if (width) image.sizes = `${width}px`; };
  const resize = new ResizeObserver(entries => entries.forEach(entry => size(entry.target)));
  const hydrate = () => document.querySelectorAll(selector).forEach(image => {
    if (image.dataset.qgcSharpCard) return;
    const url = new URL(image.getAttribute('src') || image.currentSrc, location.href);
    if (!url.pathname.includes('/cdn/') && !url.hostname.endsWith('shopify.com')) return;
    ['width', 'height', 'crop'].forEach(key => url.searchParams.delete(key));
    image.dataset.qgcSharpCard = 'true';
    size(image);
    image.srcset = [320, 480, 640, 960].map(width => { const candidate = new URL(url); candidate.searchParams.set('width', width); return `${candidate.href} ${width}w`; }).join(', ');
    resize.observe(image);
  });
  const start = () => { hydrate(); new MutationObserver(records => { if (records.some(record => record.addedNodes.length)) hydrate(); }).observe(document.querySelector('.qgc-site-content') || document.body, {childList:true,subtree:true}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();

// Open original product photos in an accessible, navigable overlay.
(() => {
  let dialog, photos = [], index = 0, trigger, oldOverflow;
  const photoLink = '#main-product .l4pr-container a[data-fancybox]';
  const isPhoto = link => /\.(?:png|jpe?g|webp|avif)(?:\?|$)/i.test(link.href);
  const show = next => {
    index = (next + photos.length) % photos.length;
    const image = dialog.querySelector('img'); image.src = photos[index].href; image.alt = photos[index].querySelector('img')?.alt || 'Product photo';
    dialog.querySelector('[data-count]').textContent = `${index + 1} / ${photos.length}`;
    dialog.querySelectorAll('[data-photo]').forEach((button, position) => button.setAttribute('aria-current', String(position === index)));
    dialog.querySelectorAll('[data-step]').forEach(button => { button.hidden = photos.length < 2; });
  };
  const build = () => {
    dialog = document.createElement('dialog'); dialog.className = 'qgc-photo-lightbox'; dialog.setAttribute('aria-label', 'Product photos');
    dialog.innerHTML = '<button type="button" class="qgc-photo-close" aria-label="Close photos">×</button><div class="qgc-photo-stage"><button type="button" data-step="-1" aria-label="Previous photo">‹</button><img alt=""><button type="button" data-step="1" aria-label="Next photo">›</button></div><p data-count aria-live="polite"></p><div class="qgc-photo-thumbs" aria-label="Choose photo"></div>';
    document.body.append(dialog);
    dialog.querySelector('.qgc-photo-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      // Backdrop clicks target the dialog in browsers. Check the pointer is outside its box.
      if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) { dialog.close(); return; }
      }
      const step = event.target.closest('[data-step]'); if (step) show(index + Number(step.dataset.step));
      const thumb = event.target.closest('[data-photo]'); if (thumb) show(Number(thumb.dataset.photo));
    });
    dialog.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); } });
    dialog.addEventListener('close', () => { document.documentElement.style.overflow = oldOverflow; trigger?.focus({preventScroll:true}); });
    let touchX;
    dialog.querySelector('.qgc-photo-stage').addEventListener('touchstart', event => { touchX = event.changedTouches[0].clientX; }, {passive:true});
    dialog.querySelector('.qgc-photo-stage').addEventListener('touchend', event => { const delta = event.changedTouches[0].clientX - touchX; if (Math.abs(delta) > 50) show(index + (delta < 0 ? 1 : -1)); }, {passive:true});
  };
  document.addEventListener('click', event => {
    const link = event.target.closest(photoLink); if (!link || !isPhoto(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); event.stopImmediatePropagation(); trigger = link;
    photos = Array.from(document.querySelectorAll(photoLink)).filter(isPhoto).filter((item, position, all) => all.findIndex(other => other.href === item.href) === position);
    if (!dialog) build();
    const thumbs = dialog.querySelector('.qgc-photo-thumbs'); thumbs.replaceChildren();
    photos.forEach((photo, position) => { const button = document.createElement('button'); button.type = 'button'; button.dataset.photo = position; button.setAttribute('aria-label', `View photo ${position + 1}`); const image = document.createElement('img'); image.src = photo.dataset.galleryThumb?.trim() || photo.querySelector('img')?.currentSrc || photo.href; image.alt = ''; button.append(image); thumbs.append(button); });
    show(Math.max(0, photos.findIndex(photo => photo.href === link.href)));
    oldOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; dialog.showModal();
  }, true);
})();

(() => {
  // Keep the mobile introduction price in sync with Shopify's native price.
  const syncMobilePrice = () => {
    const product = document.getElementById('main-product');
    if (!product) return;
    const intro = product.querySelector(':scope > header:not(.mobile-hide)');
    if (!intro) return;
    const mobilePrice = document.createElement('p');
    mobilePrice.className = 'qgc-product-mobile-price';
    mobilePrice.setAttribute('data-qgc-mobile-price', '');
    intro.append(mobilePrice);
    const sync = () => {
      const source = product.querySelector('.f8pr-price');
      if (!source) return;
      const text = source.textContent.trim();
      product.querySelectorAll('[data-qgc-mobile-price]').forEach(price => {
        if (price.textContent !== text) price.textContent = text;
      });
    };
    sync();
    new MutationObserver(sync).observe(product, {childList:true,subtree:true,characterData:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncMobilePrice, {once:true});
  else syncMobilePrice();
  // The full native gallery remains server-rendered. These are duplicate
  // editorial photos: reserve their existing frames, then load near the reader.
  const loadEditorialImages = () => {
    const templates = document.querySelectorAll('[data-qgc-deferred-product-image]');
    if (!templates.length) return;
    const hydrate = template => template.replaceWith(template.content.cloneNode(true));
    if (!('IntersectionObserver' in window)) { templates.forEach(hydrate); return; }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const template = entry.target.querySelector('[data-qgc-deferred-product-image]');
        if (template) hydrate(template);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });
    templates.forEach(template => observer.observe(template.parentElement));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadEditorialImages, { once: true });
  else loadEditorialImages();
  document.addEventListener('shopify:section:load', loadEditorialImages);
  const starRating = (score, className = 'qgc-rating') => {
    const el = document.createElement('div'); el.className = className;
    el.setAttribute('role', 'img'); el.setAttribute('aria-label', `${score} out of 5 stars`);
    el.style.setProperty('--rating-fill', `${Math.max(0, Math.min(100, score * 20))}%`);
    for (let i = 0; i < 2; i++) { const span = document.createElement('span'); span.textContent = '★★★★★'; span.setAttribute('aria-hidden', 'true'); el.append(span); }
    return el;
  };
  const initialise = () => {
    document.querySelectorAll('[data-qgc-product-editorial]').forEach(section => {
      const native = section.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
      const productCount = Number(native?.dataset.numberOfReviews || 0);
      const source = productCount > 0 ? native : section.querySelector('.qgc-product-store-review-source');
      const reviews = Array.from(source?.querySelectorAll('.jdgm-rev') || []).slice(0, 12);
      const cards = section.querySelector('[data-qgc-product-review-cards]');
      if (reviews.length && cards && cards.dataset.ready !== String(productCount)) {
        cards.dataset.ready = String(productCount); cards.replaceChildren();
        for (const review of reviews) {
          const body = review.querySelector('.jdgm-rev__body')?.textContent.trim();
          if (!body) continue;
          const card = document.createElement('article'); card.className = 'qgc-product-review-card';
          card.append(starRating(Number(review.querySelector('.jdgm-rev__rating')?.dataset.score || 0)));
          const quote = document.createElement('p'); quote.textContent = `“${body}”`;
          card.append(quote);
          if (body.length > 190) {
            quote.className = 'qgc-product-review-excerpt';
            const expand = document.createElement('button'); expand.type = 'button'; expand.className = 'qgc-product-review-expand'; expand.textContent = 'Read full review'; expand.setAttribute('aria-expanded', 'false');
            expand.addEventListener('click', () => { const expanded = card.classList.toggle('is-expanded'); expand.setAttribute('aria-expanded', String(expanded)); expand.textContent = expanded ? 'Show less' : 'Read full review'; }); card.append(expand);
          }
          const footer = document.createElement('footer'); const name = document.createElement('strong');
          name.textContent = review.querySelector('.jdgm-rev__author')?.textContent.trim() || 'Customer'; footer.append(name);
          if (review.dataset.verifiedBuyer === 'true') footer.append(document.createTextNode(' · Verified buyer'));
          card.append(footer);
          if (!productCount) {
            const productLink = review.querySelector('.jdgm-rev__prod-link');
            if (productLink) { const a = document.createElement('a'); a.href = productLink.href; a.textContent = `Reviewed: ${productLink.textContent.trim()}`; card.append(a); }
          }
          cards.append(card);
        }
        const title = section.querySelector('[data-qgc-product-reviews-title]');
        if (title) title.textContent = productCount ? 'WHAT CUSTOMERS SAY.' : 'FROM OUR CUSTOMERS.';
        const rating = section.querySelector('[data-qgc-product-review-rating]');
        const summary = productCount ? native : source?.querySelector('[data-number-of-reviews]');
        const score = Number(summary?.dataset.averageRating || 0);
        const count = Number(summary?.dataset.numberOfReviews || 0);
        if (rating && score && count) {
          rating.replaceChildren(starRating(score));
          const strong = document.createElement('strong'); strong.textContent = `${score.toFixed(2).replace(/0$/, '')} / 5`; rating.append(strong);
          const caption = document.createElement('span'); caption.textContent = `${count.toLocaleString()} ${productCount ? 'reviews of this product' : 'reviews across our store'}`; rating.append(caption);
        }
        const read = section.querySelector('[data-qgc-read-product-reviews]');
        if (read) { read.href = productCount ? '#judgeme_product_reviews' : 'https://app.judge.me/reviews/stores/quirky-giftco.myshopify.com'; read.textContent = productCount ? 'Read all product reviews →' : 'Read all store reviews →'; }
      }
      const carousel = section.querySelector('.qgc-product-review-carousel');
      if (carousel && cards && !carousel.dataset.initialised) {
        carousel.dataset.initialised = 'true';
        let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        let hovered = false, focused = false;
        const pause = carousel.querySelector('[data-qgc-product-review-pause]');
        const updatePause = () => { pause.textContent = paused ? 'Resume sliding' : 'Pause sliding'; pause.setAttribute('aria-pressed', String(paused)); };
        updatePause(); pause.addEventListener('click', () => { paused = !paused; updatePause(); });
        const move = direction => {
          const width = (cards.querySelector('article')?.getBoundingClientRect().width || 280) + 16;
          const end = cards.scrollWidth - cards.clientWidth;
          const target = direction > 0 && cards.scrollLeft >= end - 3 ? 0 : direction < 0 && cards.scrollLeft <= 3 ? end : cards.scrollLeft + width * direction;
          cards.scrollTo({left: Math.max(0, target), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        carousel.querySelectorAll('[data-qgc-product-review-step]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.qgcProductReviewStep))));
        carousel.addEventListener('mouseenter', () => { hovered = true; }); carousel.addEventListener('mouseleave', () => { hovered = false; });
        carousel.addEventListener('focusin', () => { focused = true; }); carousel.addEventListener('focusout', event => { focused = carousel.contains(event.relatedTarget); });
        cards.addEventListener('keydown', event => { if (event.target === cards && ['ArrowLeft', 'ArrowRight'].includes(event.key)) { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); } });
        const interval = setInterval(() => { if (!section.isConnected) { clearInterval(interval); return; } if (!paused && !hovered && !focused && !document.hidden && !cards.querySelector('.is-expanded') && cards.scrollWidth > cards.clientWidth + 3) { const rect = cards.getBoundingClientRect(); if (rect.bottom > 0 && rect.top < window.innerHeight) move(1); } }, 6500);
      }
      if (!reviews.length && cards && !cards.dataset.empty) { cards.dataset.empty = 'true'; cards.textContent = 'Be the first to review this gift. Share your experience below.'; }
    });
    const related = document.querySelector('.qgc-site-content [id*="recommendations"]');
    if (related) related.classList.add('qgc-product-related');
    const nativeDetails = document.querySelector('#qgc-product-native-reviews');
    document.querySelectorAll('a[href="#judgeme_product_reviews"]').forEach(link => {
      if (link.dataset.qgcReviewLink) return;
      link.dataset.qgcReviewLink = 'true'; link.addEventListener('click', () => { if (nativeDetails) nativeDetails.open = true; });
    });
  };
  let timer;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(initialise, 120); };
  document.addEventListener('DOMContentLoaded', () => {
    // Gallery/variant mutations do not change reviews. Observe only review sources.
    document.querySelectorAll('[data-qgc-product-editorial]').forEach(section => {
      const visibility = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        visibility.disconnect(); initialise();
        section.querySelectorAll('#judgeme_product_reviews,.qgc-product-store-review-source').forEach(source => {
          new MutationObserver(schedule).observe(source, {childList:true,subtree:true});
        });
      }, {rootMargin:'300px'});
      visibility.observe(section);
    });
    // Links to native review controls must work before the editorial section is visible.
    document.querySelectorAll('a[href="#judgeme_product_reviews"]').forEach(link => {
      link.dataset.qgcReviewLink = 'true';
      link.addEventListener('click', () => { const details = document.querySelector('#qgc-product-native-reviews'); if (details) details.open = true; });
    });
  });
  document.addEventListener('shopify:section:load', schedule);
})();

// Preview destination estimates instantly without changing the shopper's market or basket.
document.addEventListener('change', event => {
  const select = event.target.closest('[data-qgc-delivery-country]');
  if (!select) return;
  const panel = select.closest('.qgc-product-delivery');
  const option = select.selectedOptions[0];
  const transit = option.dataset.transit;
  panel.querySelector('[data-qgc-transit]').textContent = transit || 'Timing confirmed at checkout';
  panel.querySelector('[data-qgc-destination]').textContent = 'Delivery to ' + option.textContent.trim();
  panel.querySelector('[data-qgc-customs]').hidden = option.value === 'GB';
});

// Keep the mobile chat activator clear of the purchase button without hiding chat.
(() => {
  const mobile = matchMedia('(max-width: 749px)');
  let frame = 0;
  const position = () => {
    frame = 0;
    const host = document.querySelector('shopify-chat');
    if (!mobile.matches) { if (host) { host.style.removeProperty('--qgc-chat-lift'); host.dataset.qgcChatLift = '0'; } return; }
    const chat = host?.shadowRoot?.querySelector('[part="activator"]');
    const buy = document.querySelector('#main-product .overlay-buy_button');
    if (!host || !chat || !buy) return;
    const lift = Number(host.dataset.qgcChatLift || 0);
    const a = chat.getBoundingClientRect(), b = buy.getBoundingClientRect();
    const bottom = a.bottom + lift, top = a.top + lift;
    const overlaps = mobile.matches && chat.getAttribute('aria-expanded') !== 'true' &&
      b.right > a.left && b.left < a.right && b.bottom > top && b.top < bottom;
    const next = overlaps ? Math.max(0, bottom - b.top + 12) : 0;
    if (next !== lift) {
      host.dataset.qgcChatLift = String(next);
      host.style.setProperty('--qgc-chat-lift', next + 'px');
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(position); };
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  document.addEventListener('DOMContentLoaded', schedule);
  const arrival = new MutationObserver(() => {
    if (!document.querySelector('shopify-chat')) return;
    schedule(); arrival.disconnect();
  });
  arrival.observe(document.documentElement, {childList:true,subtree:true});
})();

// A purchasing panel sticks only when the complete panel fits on screen.
(() => {
 const start = () => { const panel = document.querySelector('#main-product>.qgc-purchase-panel'); if (!panel) return;
 const fit = () => panel.classList.toggle('qgc-purchase-fits', innerWidth >= 750 && panel.getBoundingClientRect().height + 120 < innerHeight);
 new ResizeObserver(fit).observe(panel); addEventListener('resize', fit, {passive:true}); fit(); };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
